import React, { useState } from 'react'

const defaultContexto = {
  bloquearChecks: false,
  setbloquearChecks:(estado:boolean) =>{},
  mostrarModalReplanificacion : false,
  setmostrarModalReplanificacion:(estado:boolean) =>{},

}

const SolicitudesPermisosContext = React.createContext(
  {
    ...defaultContexto
  }
)


export function useSolicitudPermisosContext() {
    const contexto = React.useContext(SolicitudesPermisosContext);
    if (!contexto) {
        throw new Error('Para usar el hook asegurese de ser hijo del Proveedor SolicitudVacacionesContextProvider');
    }
    return contexto;
}



const SolicitudPermisosContextProvider:React.FC = ({children}) => {
  const [bloquearChecks, setbloquearChecks] = useState<boolean>(false);
  const [mostrarModalReplanificacion, setmostrarModalReplanificacion] = useState(false)
  const value = {
    bloquearChecks,
    setbloquearChecks,
    mostrarModalReplanificacion,
    setmostrarModalReplanificacion
  }

  return (

      <SolicitudesPermisosContext.Provider value={value}>
          {children}
      </SolicitudesPermisosContext.Provider>
  
  )
}

export default SolicitudPermisosContextProvider;
